import { Button } from '@/components/Button/Button';

import OnboardingWrapper from '@/components/Onboarding/OnboardingWrapper';
import { cn } from '@/utils/utils';

const OnboardingPurpose = ({
  handlePurposeSelect,
  selectedPurpose,
  handleNextStep,
}: {
  handlePurposeSelect: (purpose: 'work' | 'study' | 'personal') => void;
  selectedPurpose: 'work' | 'study' | 'personal' | null;
  handleNextStep: () => void;
}) => {
  return (
    <OnboardingWrapper
      heading="How are you planning to use Anara?"
      subHeading="This helps us customize your experience"
    >
      <div className="w-full flex flex-col mb-2 gap-2">
        <Button
          variant="onboarding"
          onClick={() => handlePurposeSelect('work')}
          className={cn(
            selectedPurpose === 'work' && 'bg-badgeLightBlue border-badgeBlue',
          )}
        >
          For work
        </Button>
        <Button
          variant="onboarding"
          onClick={() => handlePurposeSelect('study')}
          className={cn(
            selectedPurpose === 'study' && 'bg-badgeLightBlue border-badgeBlue',
          )}
        >
          For studying
        </Button>
        <Button
          variant="onboarding"
          onClick={() => handlePurposeSelect('personal')}
          className={cn(
            selectedPurpose === 'personal' &&
              'bg-badgeLightBlue border-badgeBlue',
          )}
        >
          For personal use
        </Button>
      </div>

      <Button
        className="h-11 rounded-xl hover:scale-[1.02] ease-in transition-transform"
        onClick={handleNextStep}
        disabled={!selectedPurpose}
      >
        Continue
      </Button>
    </OnboardingWrapper>
  );
};

export default OnboardingPurpose;
